import { forwardRef, useEffect } from "react"
import { Box } from "@mui/material"
import TooltipSeeker from "./TooltipSeeker"

const FA_KIT_ID = "font-awesome-styles"

const IconSeeker = forwardRef(function IconSeeker(
    { icon, iconWeight = "solid", isSpin = false, className = "", tooltip = null, iconType, ...props },
    ref
) {
    useEffect(() => {
        if (!document.getElementById(FA_KIT_ID)) {
            const script = document.createElement("script")
            script.src = "https://kit.fontawesome.com/f8039a9404.js"
            script.crossOrigin = "anonymous"
            script.id = FA_KIT_ID
            document.getElementsByTagName("head")[0].appendChild(script)
        }
    }, [])

    const spin = isSpin ? "fa-spin" : ""
    const icon_element = (
        <Box
            component="i"
            ref={ref}
            {...props}
            className={`fa-${iconWeight} fa-${icon} ${spin} ${className}`}
        />
    )

    if (tooltip) {
        return <TooltipSeeker title={tooltip}>{icon_element}</TooltipSeeker>
    }

    return icon_element
})

export default IconSeeker
